import React from 'react'
import { useThankYouNote } from './ThankYouNoteProvider'
import { Button } from '../../lib/ui/button'
import SaveModal from './SaveModal'
import { useTranslation } from '~/hooks/useTranslation'

const PdfViewerPanel = () => {
  const { t } = useTranslation('Editor')
  const {
    thankYouNoteName,
    persistThankYouNote,
    pdf: { url, loading },
  } = useThankYouNote()

  if (loading) {
    return null
  }
  return (
    <>
      <div className="mb-10 flex h-16 w-full flex-row items-center justify-evenly sm:mb-0 md:absolute md:bg-[#525659]">
        <Button variant="outline" asChild>
          <a
            href={url}
            onClick={persistThankYouNote}
            download={`${thankYouNoteName}.pdf`}
            className="text-cod-gray-700"
          >
            {t('download_pdf')}
          </a>
        </Button>
        <SaveModal />
      </div>
      <iframe
        src={`${url}#toolbar=0&navpanes=0`}
        className="tw-hidden h-full w-full pt-16 md:block"
        title="Thank-You Note Preview"
        frameBorder="0"
        loading="lazy"
      />
    </>
  )
}
export default PdfViewerPanel
